// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__E1XA5","wrapper":"Container_wrapper__qqm27","title":"Container_title__j1uly"};